<template>
    <div >

        <!-- active quests -->
        <div class="TQ_padding_16px">
                <!-- todo: ass_strings -->

            <!-- choose quests -->
            <div>
                <!-- title -->
                <div class="TQ_text_20px TQ_font_SecularOne TQ_text_capitalize">
                    Active Quests
                </div>

                <!--  -->
                <div class="TQ_padding_16px">
                    Currently dont have any active quests.
                </div>

            </div>
          

            <div class="TQ_btn TQ_btn_success TQ_maxWidth_200px TQ_width_100p TQ_padding_8px TQ_borderRadius" @click="popupShow_newPayment_vb.val = true">
                Active Quests Now
            </div>
        
            <tq-popup :show="popupShow_newPayment_vb" :showCloseBtn="true" maxWidth="600px" padding="0px">
                <div class="TQ_text_bold TQ_bg_purple_dark TQ_padding_8px"> Activate Quests </div>

                <div class="TQ_padding_8px">

                    <!-- 1) select quests and date -->
                    <div v-if="currentStep_n == 0">

                        <!-- dates -->
                        <div class="TQ_margin_bottom_8px">
                                            <!-- todo: ass_strings -->
                            <div class="TQ_inline TQ_margin_8px">
                                <div class="TQ_font_SecularOne TQ_text_capitalize">
                                    Starting Date
                                </div>
                                <input type="date" class="TQ_padding_8px TQ_width_150px TQ_borderRadius TQ_box_shadow TQ_border_none" @change="m_changeDate_f" v-model="currentDate_s" :min="minDate_s" />
                            </div>
                            <div class="TQ_inline TQ_margin_8px">
                                <div class="TQ_font_SecularOne TQ_text_capitalize">
                                    Duration
                                </div>
                                <div class="TQ_margin_8px TQ_text_capitalize" v-if="newPaymentRequest_c">
                                    <span class="TQ_padding_8px TQ_clickable TQ_borderRadius_left TQ_box_shadow" 
                                        :class="[newPaymentRequest_c.pr_type_e==enum_subscriptionTypes.monthly && 'TQ_bg_purple_lite']"
                                        @click="newPaymentRequest_c.pr_type_e=enum_subscriptionTypes.monthly">monthly</span>

                                   <span class="TQ_padding_8px TQ_clickable TQ_borderRadius_right TQ_box_shadow" 
                                        :class="[newPaymentRequest_c.pr_type_e==enum_subscriptionTypes.yearly && 'TQ_bg_purple_lite']"
                                        @click="newPaymentRequest_c.pr_type_e=enum_subscriptionTypes.yearly"> yearly</span>     
                                </div>
                            </div>

                        </div>
                    

                        <!-- quests table -->
                        <div class="TQ_margin_bottom_8px">

                            <div class="TQ_font_SecularOne TQ_text_capitalize">
                                Quests To Activate
                            </div>

                            <tq-table
                                v-if="server_questsExplore_ac"
                                :rows="server_questsExplore_ac"
                                :system-lang-code="store_langCode_vs.val"
                                :display-search="true"
                                p_td-classes_s="TQ_padding_4px"
                                :p_showMaxRows_b="false"
                                :columns="[
                                    {label : ass_strings.oneWord_image[store_langCode_vs.val],       class_s: () => {return 'TQ_width_52px'},        img_f: (questExplore_c) => questExplore_c.qex_imgsFiles_blc_ac[questExplore_c.cm_qex_getDisplayLang_fe(store_langCode_vs.val)][0].fi_url_s},
                                    {label : ass_strings.oneWord_name[store_langCode_vs.val],        class_s: () => {return ''},   field : questExplore_c => questExplore_c.qex_name_byLangCode_s[questExplore_c.cm_qex_getDisplayLang_fe(store_langCode_vs.val)] },
                                ]"
                                :p_actions_ao="[{   
                                        attId: 'qex_questId_uid',
                                        onCheck_f : m_chooseQuest_f, 
                                        checked_f : questExplore_c => !!selectedQuests_byId_c[questExplore_c.qex_questId_uid],  
                                        class : 'TQ_width_24px' 
                                    },]"
                            />

                        </div>

                        <!-- buttons -->
                        <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px">
                            <div class="TQ_width_150px TQ_grid_verticalCenter">
                            </div>

                            <div class="TQ_grid_verticalCenter">
                            </div>

                            <div @click="m_nextStep_f" class="TQ_btn TQ_bg_purple_lite TQ_borderRadius TQ_width_150px TQ_grid_verticalCenter   ">
                                <!-- todo: ass_strings -->
                                Next 
                            </div>
                        </div>
                    </div>
                    

                    <!-- 2) pay -->
                    <div v-else-if="currentStep_n == 1">

                        <tq-table
                            class="TQ_padding_8px TQ_bg_white TQ_margin_8px TQ_selectable "
                            :rows="newPaymentRequest_c.pr_questsPointers_ac"
                            :system-lang-code="store_langCode_vs.val"
                            :display-search="false"
                            p_td-classes_s="TQ_padding_4px"
                            :p_showMaxRows_b="false"
                            :columns="[
                                {label : ass_strings.oneWord_image[store_langCode_vs.val],       class_s: () => {return 'TQ_width_52px'},        img_f: (questExplore_c) => questExplore_c.qex_imgsFiles_blc_ac[questExplore_c.cm_qex_getDisplayLang_fe(store_langCode_vs.val)][0].fi_url_s},
                                {label : ass_strings.oneWord_name[store_langCode_vs.val],        class_s: () => {return ''},    field : questExplore_c => questExplore_c.qex_name_byLangCode_s[questExplore_c.cm_qex_getDisplayLang_fe(store_langCode_vs.val)] },
                            ]"
                        />


                        <div class="TQ_padding_8px">
                            <table class="TQ_width_100p lc_sumTable TQ_box_shadow">
                                <tr class="TQ_text_capitalize">
                                    <!-- todo: ass_strings -->
                                    <th>quests</th>
                                    <th>Quest Cost</th>
                                    <th>starting date</th>
                                    <th>ending date</th>
                                    <th>Total</th>
                                </tr>

                                <tr>
                                    <td>{{ newPaymentRequest_c.pr_questsPointers_ac.length }}</td>
                                    <td>{{ format_cost_s(newPaymentRequest_c.pr_m_monthlyCost_fc())}}</td>
                                    <td>{{ format_date_YYYY_MM_DD_fs(newPaymentRequest_c.pr_startingDate_t) }}</td>
                                    <td>{{ format_date_YYYY_MM_DD_fs(newPaymentRequest_c.pr_m_endingDate_t()) }}</td>
                                    <td>{{ format_cost_s(newPaymentRequest_c.pr_m_questCost_fc()) }}</td>
                                </tr>
                            </table>
                        </div>
                     


                        <div class="TQ_padding_8px"></div>

                        <!-- buttons -->
                        <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px">
                            <!-- todo: ass_strings -->
                            <div @click="currentStep_n--" class="TQ_btn TQ_borderRadius TQ_width_150px TQ_grid_verticalCenter TQ_bg_gray3">
                                Go Back
                            </div>

                            <div class="TQ_grid_verticalCenter">
                            </div>

                            <!-- todo: ass_strings -->
                            <div @click="m_activateNewQuests_f" class="TQ_btn TQ_bg_purple_lite TQ_borderRadius TQ_width_150px TQ_grid_verticalCenter   ">
                                Approve And Pay
                            </div>
                        </div>
                    </div>

                </div>

            </tq-popup>

            
        </div>

        <hr>

    </div>
</template>

<script>
import TqPopup from '../basic/TqPopup.vue'
import { serverBig_getQuestsExplore_filterByCreatorId_f } from '@/scripts/Server/S_ServerFirestore'
import { store_getStateValue_vo, store_var } from '@/store'
import TqImage from '../basic/TqImage.vue'
import TqCheckbox from '../basic/TqCheckbox.vue'
import TqTable from '../basic2/TqTable.vue'
import { ass_strings } from '../../../functions/src/shareCode/Share_Ass_Dictionary'
import { FB_PaymentRequest } from '../../../functions/src/shareCode/Share_S_Classes'
import { enum_paymentRequestBy, enum_paymentRequestStatus, enum_subscriptionTypes } from '../../../functions/src/shareCode/Share_S_Enum'
import { date_nowTime_t } from '../../../functions/src/shareCode/Share_S_Date'
import { serverAuth_currentUserData_get_vl_fp } from '@/scripts/Server/S_ServerAuth'
import { format_cost_s, format_date_input_fs, format_date_YYYY_MM_DD_fs} from '../../../functions/src/shareCode/Share_S_Format'
import { notification_notify2 } from '@/scripts/S_Notification'

export default {
  components: { TqPopup, TqImage, TqCheckbox, TqTable },
    name: "TquCreatorManagePayment",
    data(){
        return {    
            showLoader_b:true,
            popupShow_newPayment_vb:{ val: false},
            selectedQuests_byId_c: {},
            currentStep_n: 0,
            currentDate_s: format_date_input_fs(date_nowTime_t()),
            minDate_s: format_date_input_fs(date_nowTime_t()),

            newPaymentRequest_c : undefined,

            // import
            ass_strings: ass_strings,
            format_date_YYYY_MM_DD_fs,
            format_cost_s,
            enum_subscriptionTypes,

            // store
            store_langCode_vs: store_getStateValue_vo(store_var.system_langCode),
            
            // server
            server_questsExplore_ac: undefined,
        }
    },
    methods: {
        m_chooseQuest_f(questExplore_c){
            if(this.selectedQuests_byId_c[questExplore_c.qex_questId_uid] ){
                delete this.selectedQuests_byId_c[questExplore_c.qex_questId_uid] 
            }else{
                this.selectedQuests_byId_c[questExplore_c.qex_questId_uid] = questExplore_c
            }

            console.log(this.newPaymentRequest_c)
            this.newPaymentRequest_c.pr_questsPointers_ac = Object.values(this.selectedQuests_byId_c)
        },
        m_changeDate_f(){
            this.newPaymentRequest_c.pr_startingDate_t = new Date(this.currentDate_s)
        },
        m_nextStep_f(){

            if(this.newPaymentRequest_c.pr_questsPointers_ac.length === 0){
                notification_notify2({
                    title_s: ass_strings.oneWord_error[this.store_langCode_vs.val],
                    text_s: "please choose quests to activate" // todo: ass_strings
                })

                return 
            }

            const minDate_d = new Date(this.minDate_s)

            if(this.newPaymentRequest_c.pr_startingDate_t < minDate_d.getTime()){
                notification_notify2({
                    title_s: ass_strings.oneWord_error[this.store_langCode_vs.val],
                    text_s: "cant choose passed date" // todo: ass_strings
                })

                return 
            }

            this.currentStep_n = 1
        },
        m_activateNewQuests_fp(){
            
        }
    },
    created(){

        // 1) get currentUserData
        serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData_c) => {
            
            this.server_currentUserData_c = currentUserData_c

            if(currentUserData_c == null){
                this.showLoader_b = false
                return
            }

            this.newPaymentRequest_c = new FB_PaymentRequest({
                pr_creatorId_uid: currentUserData_c.ud_userId_uid,
                pr_type_e: enum_subscriptionTypes.monthly,
                pr_startingDate_t: date_nowTime_t(),
                pr_autoRenew_b: true,
                pr_status_e: enum_paymentRequestStatus.request,
                pr_requestBy_e: enum_paymentRequestBy.user,
                pr_startingDate_t: (new Date()).getTime()
            }),

            serverBig_getQuestsExplore_filterByCreatorId_f(this.server_currentUserData_c.ud_userId_uid, false, (questExplore_ac) => {
                this.server_questsExplore_ac = questExplore_ac
            })

        })


    }
}
</script>

<style lang="scss" scoped>

.lc_sumTable {
    border: 1px solid black;
    border-collapse: collapse;

    th{
        background: var(--color-gray12);
    }
    tr, td, th{
        border: 1px solid black;
    }

    td, th{
        padding: 8px;
    }
}
</style>